export const pageStatus = {
  table: {
    column: {
      1: { en: 'No', ko: '넘버', fr: '' },
      2: { en: 'page active', ko: '페이지 활성화', fr: '' },
      3: { en: 'category', ko: '구분', fr: '' },
      4: { en: 'page name', ko: '페이지명', fr: '' },
      5: { en: 'layout', ko: '레이아웃', fr: '' },
      6: { en: 'page code', ko: '페이지코드', fr: '' },
      7: { en: 'mobile link', ko: '모바일', fr: '' },
      8: { en: 'link', ko: '링크', fr: '' },
      9: { en: 'edit', ko: '관리', fr: '' },
    },
  },
  editLinkInfoModal: {
    title: { en: 'Link info', ko: '링크 정보', fr: '' },
    subtitle: { en: 'edit link info form', ko: '링크 정보 내용을 수정합니다.', fr: '' },
  },
};
